import { createUiBindings } from '@ff-scene-plugins/gift-redux/slices/uiSlice';

const { createSelector, createUpdateAction } = createUiBindings();

export const selectIsGiftWindowOpen = createSelector(state => state.isGiftWindowOpen);
export const setIsGiftWindowOpen = createUpdateAction('isGiftWindowOpen');

export const selectShowProjectIsIncompatible = createSelector(state => state.showProjectIncompatible);
export const setShowProjectIsIncompatible = createUpdateAction('showProjectIncompatible');

export const selectArPreviewStatus = createSelector(state => state.arPreviewStatus);
export const setArPreviewStatus = createUpdateAction('arPreviewStatus');

export const selectIsArQrWindowOpen = createSelector(state => state.isArQrWindowOpen);
export const setIsArQrWindowOpen = createUpdateAction('isArQrWindowOpen');